<template>
	<div>
		<h1>Szilenciumok telítettsége</h1>
		<v-row>
			<v-col cols="12" sm="12">
				<v-menu
		      v-model="hetfovalaszto.menu"
		      :close-on-content-click="false"
		      transition="scale-transition"
		      offset-y
		      min-width="290px"
		    >
		      <template v-slot:activator="{ on, attrs }">
		        <v-text-field
		          v-model="hetfovalaszto.datum"
		          label="Hét kezdőnapja"
		          prepend-inner-icon="fa-calendar"
		          readonly
		          v-bind="attrs"
		          v-on="on"
		        ></v-text-field>
		      </template>
		      <v-date-picker
		        v-model="hetfovalaszto.datum"
		        no-title
		        scrollable
						:allowed-dates="hetfok"
						first-day-of-week="1"
						@input="hetfovalaszto.menu=false, tablazatfrissitese()"
		      >
		      </v-date-picker>
		    </v-menu>
			</v-col>
		</v-row>
		<v-data-table
			:headers="tablazat.fejlecek"
			:items="adatok.szilenciumok"
			sort-by="szam"
			hide-default-footer
      disable-pagination
		>

			<template v-slot:item.szam="{item}">
				{{item.szam}}. szilencium ({{item.idopont}})
			</template>

			<template v-slot:item.hetfo="{item}" >
        {{adatok.telitettseg.find(t => t.nap==hettetszolegesnapja(0)&&t.szilenciumid==item.id)? adatok.telitettseg.find(t => t.nap==hettetszolegesnapja(0)&&t.szilenciumid==item.id).letszam : 0}}/{{item.letszamkorlat}}
			</template>
      <template v-slot:item.kedd="{item}" >
        {{adatok.telitettseg.find(t => t.nap==hettetszolegesnapja(1)&&t.szilenciumid==item.id)? adatok.telitettseg.find(t => t.nap==hettetszolegesnapja(1)&&t.szilenciumid==item.id).letszam : 0}}/{{item.letszamkorlat}}
			</template>
      <template v-slot:item.szerda="{item}" >
        {{adatok.telitettseg.find(t => t.nap==hettetszolegesnapja(2)&&t.szilenciumid==item.id)?adatok.telitettseg.find(t => t.nap==hettetszolegesnapja(2)&&t.szilenciumid==item.id).letszam:0}}/{{item.letszamkorlat}}
			</template>
      <template v-slot:item.csutortok="{item}" >
        {{adatok.telitettseg.find(t => t.nap==hettetszolegesnapja(3)&&t.szilenciumid==item.id)?adatok.telitettseg.find(t => t.nap==hettetszolegesnapja(3)&&t.szilenciumid==item.id).letszam:0}}/{{item.letszamkorlat}}
			</template>

		</v-data-table>
		<v-snackbar
		 v-model="snackbar.megnyit"
		>
		 {{ snackbar.szoveg }}
		 <v-btn
			 color="pink"
			 text
			 @click="snackbar.megnyit = false"
		 >
			 Bezár
		 </v-btn>
		</v-snackbar>
	</div>
</template>

<script>
	import router from '../router';
	export default {
		data: function(){
			return {
				snackbar: {
					megnyit: false,
					szoveg: ""
				},
				hetfovalaszto: {
					menu: false,
					datum: this.aktualishetfo()
				},
				tablazat: {
          mutat: true,
					fejlecek: [
						{
							text: "Szilencium",
							value: "szam",
							align: "center",
							sortable: false,
							filterable: false,
							groupable: false
						},
						{
							text: "Hétfő",
							value: "hetfo",
							align: "left",
							sortable: false,
							filterable: false,
							groupable: false
						},
						{
							text: "Kedd",
							value: "kedd",
							align: "left",
							sortable: false,
							filterable: false,
							groupable: false
						},
						{
							text: "Szerda",
							value: "szerda",
							align: "left",
							sortable: false,
							filterable: false,
							groupable: false
						},
						{
							text: "Csütörtök",
							value: "csutortok",
							align: "left",
							sortable: false,
							filterable: false,
							groupable: false
						}
					]
				},
				adatok: {}
			}
		},
		computed: {

		},
		watch: {

		},
		methods: {
			tablazatfrissitese: function() {
        return new Promise((ok,nemok) => {
          this.axios.get(this.$store.state.backendeleres+"szilenciumbejegyzesek/nevelotanar/telitettseg/"+this.hetfovalaszto.datum)
                    .then((response) => {
                      if(response.data.bejelentkezve==false) this.kijelentkezes();
                      if(response.data.ok){
                         this.adatok=response.data.adatok;
                       }
                      ok();
                    })
        })

			},
			aktualishetfo: () => {var d = new Date(); var r = new Date(d.setDate(d.getDate()-d.getDay()+(d.getDay() == 0 ? -6:1))); return r.toISOString().substring(0,10)},
			hetfok: nap => new Date(Date.parse(nap)).getDay()==1,
			hettetszolegesnapja: function(nap /*0: hétfő, 1: kedd*/)  {
				var datum = new Date(Date.parse(this.hetfovalaszto.datum))
				datum.setDate(datum.getDate()+nap)
				return datum.toISOString().substring(0,10)
			}
		},
		mounted(){
        this.tablazatfrissitese()
		}
	}
</script>
